<div class="profile">

  <div class="user">
    <img class="userimg" src="https://picsum.photos/200/300?image=1027" alt="profile picture of username">

    <div class="about">
      <h1>username</h1>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aliquid, itaque?</p>

      <div class="buttons">
        <!-- hide if this your profile or not -->
        <!-- for a test can be done with user id - if odd or even -->
        <button mat-raised-button color="primary" (click)="followUser()">
          {{ following ? 'Unfollow' : 'Follow' }}
        </button>
        <a mat-button routerLinkActive="active" ariaCurrentWhenActive="page" routerLink="/profile/edit">Edit</a>
      </div>
    </div>
  </div>

  <!-- TODO https://v16.material.angular.io/components/tabs/examples#tab-group-async -->

  <mat-card class="content">
    <mat-tab-group dynamicHeight mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="300ms">
      <mat-tab label="Outfits">

        <div class="outfits">
          @for (outfitItem of outfitList; track outfitItem) {
            <app-outfit [outfit]="outfitItem"></app-outfit>
          }
        </div>

      </mat-tab>
      <mat-tab label="Clothes">
        <div class="garments">
          @for (garment of garmentList; track garment) {
            <app-garment [garment]="garment"></app-garment>
          }
        </div>
      </mat-tab>
    </mat-tab-group>

  </mat-card>
</div>